/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalyStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return CostAnomalyStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyStatusQueryOperator>): CostAnomalyStatusQueryOperator {
        let obj = Object.assign(new CostAnomalyStatusQueryOperator(), model);
        CostAnomalyStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyStatusQueryOperator>): CostAnomalyStatusQueryOperator {
        if (!model) return null;
        return CostAnomalyStatusQueryOperator.newInstance(<CostAnomalyStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyStatusQueryOperator) {
        if (!obj) return;

        models.CostAnomalyStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cost Anomaly status to include
     */
    anomaly_status: Array<models.AnomalyStatus>;

}
